export default __webpack_public_path__ + "static/media/8047b5f2b0df40c68f48ead2a80dec50.b35aafac.png";